"use strict";
exports.__esModule = true;
exports.EMBED_SIGNUP_COMPLETED = exports.EMBED_SIGNUP = void 0;
exports.EMBED_SIGNUP = {
    BODY: 'With Flexible Rent, you can split your rent into two smaller payments using a Flex line of credit.',
    CTA: 'Get started',
    HEADER: 'Pay part now, the rest later',
    LIST: {
        HEADER: 'Flexible Rent helps you',
        ITEM_1: 'Pay rent on time',
        ITEM_2: 'Improve your cash flow',
        ITEM_3: 'Build your credit history with rent reporting'
    },
    NOTICE_1: 'By continuing, you agree to Flex’s ',
    NOTICE_2: '. Flex line of credit is issued by Lead Bank. Visit ',
    NOTICE_3: ' for more info.'
};
exports.EMBED_SIGNUP_COMPLETED = {
    BODY: 'We saved your progress to make it easier for you to complete signup!',
    CTA: 'Complete signup',
    HEADER: 'Welcome back, {{firstName}}!'
};
